// Camera system for following the player
export class Camera {
    constructor(worldWidth, worldHeight, viewWidth, viewHeight) {
        this.x = 0;
        this.y = 0;
        this.worldWidth = worldWidth;
        this.worldHeight = worldHeight;
        this.viewWidth = viewWidth;
        this.viewHeight = viewHeight;

        // Camera effects
        this.shakeX = 0;
        this.shakeY = 0;
        this.shakeTime = 0;
        this.shakeAmplitude = 0;
        this.zoom = 1.0;
        this.targetZoom = 1.0;
        this.zoomTime = 0;
    }

    follow(targetX, targetY) {
        // Center camera on target
        let desiredX = targetX - this.viewWidth / 2;
        let desiredY = targetY - this.viewHeight / 2;

        // Clamp to world bounds
        // Ensure camera doesn't go beyond world boundaries
        // When camera is at maxX, the right edge of the view should be at worldWidth
        // This ensures the rightmost boundary tile is fully visible
        // When camera is at minX (0), the left edge of the view is at 0
        // This ensures the leftmost boundary tile is fully visible
        // Note: If worldWidth < viewWidth, maxX will be 0 or negative, so we use Math.max(0, ...)
        const maxX = Math.max(0, this.worldWidth - this.viewWidth);
        const maxY = Math.max(0, this.worldHeight - this.viewHeight);
        
        // Clamp camera position
        // This ensures the camera shows the full boundary tiles on all edges
        this.x = Math.max(0, Math.min(desiredX, maxX));
        this.y = Math.max(0, Math.min(desiredY, maxY));
    }

    worldToScreen(worldX, worldY) {
        return {
            x: worldX - this.x,
            y: worldY - this.y
        };
    }

    shake(amplitude, duration) {
        this.shakeAmplitude = amplitude;
        this.shakeTime = duration;
    }

    setZoom(zoom, duration) {
        this.targetZoom = zoom;
        this.zoomTime = duration;
    }

    update(dt) {
        // Update shake
        if (this.shakeTime > 0) {
            const decay = this.shakeTime / (this.shakeAmplitude / 10);
            this.shakeX = (Math.random() - 0.5) * this.shakeAmplitude * decay;
            this.shakeY = (Math.random() - 0.5) * this.shakeAmplitude * decay;
            this.shakeTime -= dt;
        } else {
            this.shakeX = 0;
            this.shakeY = 0;
        }

        // Update zoom
        if (this.zoomTime > 0) {
            const t = dt / this.zoomTime;
            this.zoom = this.zoom + (this.targetZoom - this.zoom) * t;
            this.zoomTime -= dt;
        } else {
            this.zoom = this.targetZoom;
        }
    }

    apply(ctx) {
        ctx.save();
        // Round translation to integer pixels to prevent tile flickering
        const translateX = Math.round(-this.x + this.shakeX);
        const translateY = Math.round(-this.y + this.shakeY);
        ctx.translate(translateX, translateY);
        if (this.zoom !== 1.0) {
            const centerX = this.x + this.viewWidth / 2;
            const centerY = this.y + this.viewHeight / 2;
            ctx.translate(centerX, centerY);
            ctx.scale(this.zoom, this.zoom);
            ctx.translate(-centerX, -centerY);
        }
    }

    restore(ctx) {
        ctx.restore();
    }
}
